import React from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';

/**
 * TripleInput: render FR / EN / PT input fields side by side for a multi-language field.
 *
 * Props:
 *  - content: the SiteContent object (state)
 *  - setContent: setter (state)
 *  - field: base field name (without _fr/_en/_pt suffix), e.g. "about_title"
 *  - label: human label
 *  - multiline: if true, render Textarea; otherwise Input
 *  - rows: textarea rows when multiline (default 2)
 *  - onSave: optional callback fired onBlur (auto-save)
 */
const TripleInput = ({ content, setContent, field, label, multiline = false, rows = 2, onSave }) => {
  const Comp = multiline ? Textarea : Input;
  const handleChange = (lang, value) => {
    setContent({ ...content, [`${field}_${lang}`]: value });
  };
  const handleBlur = () => {
    if (onSave) onSave();
  };
  const baseClass = `bg-transparent border-white/20 text-white text-sm ${multiline ? 'resize-none' : 'h-9'}`;
  const props = multiline ? { rows } : {};

  return (
    <div className="space-y-2">
      {label && <Label className="text-xs text-white/60 uppercase tracking-wide">{label}</Label>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {['fr', 'en', 'pt'].map(lang => (
          <div key={lang} className="space-y-1">
            <span className="text-[10px] text-[#d4af37] uppercase tracking-wider font-medium">{lang}</span>
            <Comp
              value={content?.[`${field}_${lang}`] || ''}
              onChange={(e) => handleChange(lang, e.target.value)}
              onBlur={handleBlur}
              className={baseClass}
              data-testid={`triple-input-${field}-${lang}`}
              {...props}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TripleInput;
